export default __webpack_public_path__ + "static/Effie-a50de6a087b21d22d0dd8ec294e71dfaf0e1378a5d8bbcfbaae61fc43b609bb2.svg";